import React, { useState } from "react"
import { useForm } from "react-hook-form"

const apiEndpoint = process.env.GATSBY_COMMENTS_ENDPOINT

function CommentForm({ post }) {
  const [response, setResponse] = useState("")
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    // watch,
    reset,
    // formState: { errors },
  } = useForm()
  const onSubmit = data => {
    if (loading === true) return
     
    setLoading(true)
    const postDetails = {
      ...data,
      post: parseInt(post.databaseId),
    }

    fetch(`${apiEndpoint}`, {
      method: "post",
      body: JSON.stringify(postDetails),
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        setLoading(false)
        if (data.status === "success") {
          reset()
        }
        setResponse(data.message)
      })
      .catch(function (error) {
        console.error(error)
        setResponse("There was an error submitting this form")
      })
  }

  return (
    <div className={"w-full mb-8"}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="divide-y divide-gray-200">
          <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7 "> 
            <div className="relative pb-4">
              <input
                {...register("author_name", { required: true })}
                type="text"
                autoComplete={"false"}
                className="peer placeholder-transparent dark:text-white dark:bg-gray-900  h-10 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                placeholder="First Name"
              />
              <label
                htmlFor="author_name"
                className="dark:text-white absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
              >
                First Name
              </label>
            </div>
            <div className="relative pb-4">
              <textarea
                {...register("content", { required: true })}
                type="text"
                className="peer placeholder-transparent dark:text-white dark:bg-gray-900  h-40 w-full border-b-2 border-gray-300 text-gray-900 focus:outline-none focus:borer-rose-600"
                placeholder="Let us know what you tink"
              />
              <label
                htmlFor="content"
                className="dark:text-white absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
              >
                Your Comment
              </label>
            </div>
            <div className="relative flex items-center">
              <button className="bg-purple-900 text-white rounded-md px-4 py-2">
                {loading === true ? "Loading..." : "Submit"}
              </button>
              {response && (
                <div
                  className={"pl-4 text-gray-900 dark:text-white"}
                  dangerouslySetInnerHTML={{
                    __html: response,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CommentForm
